// extracted by mini-css-extract-plugin
module.exports = {"text":"InputTextLengthLabel_text__DscrS"};